import React from 'react';
import SidebarCard from './SidebarCard';
import Field from './Field';
import AutoTextarea from './AutoTextarea';

const DESCRIPTION_LIMIT = 160;

/* Meta description with a live counter, and the listing excerpt. */
export default function SeoCard({ page, open, onToggle, onChange }) {
  const len = (page.description || '').length;
  const over = len > DESCRIPTION_LIMIT;
  return (
    <SidebarCard id="seo" title="SEO" open={open} onToggle={onToggle}>
      <Field
        id="page-description"
        label="Meta description"
        hint="Shown in search results. Aim for 160 characters or fewer."
        labelExtra={(
          <span
            aria-live="polite"
            style={{ fontSize: 12, fontWeight: 400, fontVariantNumeric: 'tabular-nums', color: over ? 'var(--color-danger)' : 'var(--color-muted)' }}
          >
            {len}/{DESCRIPTION_LIMIT}
          </span>
        )}
      >
        <AutoTextarea
          id="page-description"
          value={page.description || ''}
          onChange={(e) => onChange('description', e.target.value)}
          placeholder="One or two sentences for search engines…"
          minRows={3}
          className={`textarea${over ? ' is-invalid' : ''}`}
          aria-describedby="page-description-hint"
        />
      </Field>

      <Field id="page-excerpt" label="Excerpt" hint="Short summary for listings and previews.">
        <AutoTextarea
          id="page-excerpt"
          value={page.excerpt || ''}
          onChange={(e) => onChange('excerpt', e.target.value)}
          placeholder="A short summary…"
          minRows={3}
          aria-describedby="page-excerpt-hint"
        />
      </Field>
    </SidebarCard>
  );
}
